import React from "react";
import { useTable } from "../../Components/useTable";

const AgencyList = () => {
  const type = "All Agencies";
  const limitPerpage = 100;
  const pageRowslinit = [20, 50, 100];
  const headCells = [
    { id: "code", numeric: false, label: "Code" },
    { id: "rid", numeric: false, label: "Rid" },
    { id: "name", numeric: false, label: "Name" },
    { id: "id", numeric: false, label: "Agency ID" },
    { id: "picture", numeric: false, label: "Picture" },
    { id: "userName", numeric: false, label: "Email" },
    { id: "password", numeric: false, label: "Password" },
    { id: "level", numeric: false, label: "Level" },
    { id: "country", numeric: false, label: "Country" },
    { id: "email", numeric: false, label: "Email" },
    { id: "phone", numeric: false, label: "Phone" },
    { id: "agencyStatus", numeric: false, label: "Status" },
    { id: "totalMember", numeric: false, label: "Total Member" },
    { id: "address", numeric: false, label: "Address" },
    { id: "bankName", numeric: false, label: "Bank Name" },
    { id: "bankAccountName", numeric: false, label: "Account Name" },
    { id: "created", numeric: false, label: "Created at" },
    { id: "action", numeric: false, label: "Action" },
  ];

  const { tableUI } = useTable({
    headCells,
    type,
    limitPerpage,
    pageRowslinit,
  });
  return (
    <div className="admin-body">
      <div className="table-area">{tableUI}</div>
    </div>
  );
};

export default AgencyList;
